import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

const PrivateRoute = ({ component: Component, isLoggedin, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            isLoggedin ? <Component {...props} /> : <Redirect to="/login" />
        }
    />
);

const mapStateToProps = (state) => ({
    isLoggedin: state.loginReducer.isLoggedin,
});

export default connect(mapStateToProps)(PrivateRoute);

